import { userConstants, CouponConstants, ShopConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { userService, commonService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";
import { apiConstants } from "../_constants/api.constants";

//import rootReducer from '../_reducers';
//import { createStore } from 'redux'

//const store = createStore(rootReducer)

export const shopActions = {
  saveShopAndShopKeeper,
  getAllShopKeeper,
  getShopKeeper,
  updateShopAndShopKeeper,
  updateShopkeeperStatus
};

//-- Login function
function saveShopAndShopKeeper(apiName, shopObj) {
  return dispatch => {
    dispatch(commonAction.request(ShopConstants.SHOP_ADDED_REQUEST, shopObj));
    commonService.withTokenPut(apiName, shopObj).then(
      savedShopkeeper => {
        // console.log("retirned data----------------", shopAndShopkeeper.data);
        dispatch(commonAction.success(ShopConstants.SHOP_ADDED_SUCCESS, savedShopkeeper));
      },
      error => {
        dispatch(
          commonAction.failure(ShopConstants.SHOP_ADDED_FAILURE, error)
        );
        // dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}

function getAllShopKeeper(apiName, shopData) {

  return dispatch => {
    dispatch(commonAction.request(ShopConstants.GET_SHOP_AND_SHOPKEEPR_LIST_REQUEST, shopData));

    commonService.withToken(apiName, shopData).then(
      shopAndShopkeeper => {
        dispatch(commonAction.success(ShopConstants.GET_SHOP_AND_SHOPKEEPR_LIST_SUCCESS, shopAndShopkeeper.data));
      },
      error => {
        dispatch(
          commonAction.failure(ShopConstants.GET_SHOP_AND_SHOPKEEPR_LIST_FAILURE, error)
        );
        // dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}


function getShopKeeper(apiName, userIdObject) {

  return dispatch => {
    dispatch(commonAction.request(ShopConstants.GET_SHOPKEEPR_REQUEST, userIdObject));

    commonService.withToken(apiName, userIdObject).then(
      shopAndShopkeeper => {
        dispatch(commonAction.success(ShopConstants.GET_SHOPKEEPR_SUCCESS, shopAndShopkeeper.data));
      },
      error => {
        dispatch(
          commonAction.failure(ShopConstants.GET_SHOPKEEPR_FAILURE, error)
        );
        // dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}


function updateShopAndShopKeeper(apiName, shopObj) {
  return dispatch => {
    dispatch(commonAction.request(ShopConstants.SHOP_UPDATE_REQUEST, shopObj));
    commonService.withTokenPut(apiName, shopObj).then(
      savedShopkeeper => {
        // console.log("retirned data----------------", shopAndShopkeeper.data);
        dispatch(commonAction.success(ShopConstants.SHOP_UPDATE_SUCCESS, savedShopkeeper));
      },
      error => {
        dispatch(
          commonAction.failure(ShopConstants.SHOP_UPDATE_FAILURE, error)
        );
        // dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}

//-- Update Shopkeeper status
function updateShopkeeperStatus(apiName, userData, paramForgetUserList) {

  return dispatch => {
    dispatch(
      commonAction.request(
        userConstants.UPDATE_USER_DETAILS_REQUEST,
        userData
      )
    );
    commonService.withTokenPut(apiName, userData).then(
      user => {
        dispatch(alertActions.success("Status updated successfully"));
        setTimeout(function () {
          dispatch(alertActions.clear())
        }, 3000);

        dispatch(getAllShopKeeper(paramForgetUserList.api, paramForgetUserList))
      },
      error => {
        dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}
